export const filterOptions = {
    week: 'Последние 7 дней',
    month: '30 дней',
    threeMonths: '3 месяца',
    halfYear: 'Полгода',
    year: 'Год',
    exactDate: 'Точная дата',
};



// WEBPACK FOOTER //
// ./src/components/laws-filters/dates-filter/options.js